import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import EditQuiz from "./EditQuizDetails";
import { useDispatch, useSelector } from "react-redux";
import { setState, setUpdateQuizForm } from "../redux/slice";
import { deleteQuiz, getQuizzes, publishOrUnpublish } from "../redux/thunk";
import { getLaws } from "../../components/LawCollegeQuiz/redux/lawCollegeSlice";
import { convertTermsToHtml, formatText1 } from "../utils";
import {
  fetchQuizTypes,
  fetchSubjectBasedClassesData,
  fetchSubjects,
} from "../../components/SchoolQuiz/redux/schoolQuizSlice";
const QuizStatus = () => {
  const [searchTerm, setSearchTerm] = useState("");
  // const [quizzes, setQuizzes] = useState([]);
  const [quizType, setQuizType] = useState("");
  const [subQuizType, setSubQuizType] = useState("");
  const { quizzes, selectedQuiz, showPopup, option } = useSelector(
    (state) => state.quizManagement,
  );
  const { subjectsList, subjectBasedClasses, quizTypesList } = useSelector(
    (state) => state.schoolQuiz,
  );
  const userId = JSON.parse(localStorage.getItem("user"))?.id;
  const classes = subjectBasedClasses?.data || [];
  const subjects = subjectsList?.data || [];

  const { categories } = useSelector((state) => state.lawCollegeQuiz);
  const [countInfo, setCountInfo] = useState(null);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchSubjects());
    dispatch(fetchQuizTypes());
    // axios.get("/admin/quizzes").then((res) => setQuizzes(res.data));
  }, [dispatch]);

  const fetchParticipants = async (quiz, option) => {
    console.log("data to set", quiz);
    dispatch(
      setState({
        key: "selectedQuiz",
        value: {
          ...quiz, // existing quiz object
          quizType: quizType, // add quizType here
        },
      }),
    );

    if (option === "edit") {
      dispatch(
        setState({
          key: "option",
          value: option,
        }),
      );
      const data = quiz;
      const formatToISTDatetimeLocal = (utcDateStr) => {
        if (!utcDateStr) return "";
        const date = new Date(utcDateStr);
        const istString = date.toLocaleString("en-IN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });

        // Format returned like: "10/07/2025, 16:45"
        const [datePart, timePart] = istString.split(", ");
        const [day, month, year] = datePart.split("/");
        return `${year}-${month}-${day}T${timePart}`;
      };
      dispatch(
        setUpdateQuizForm({
          id: data.id || "",
          title: data.title || "",
          start: formatToISTDatetimeLocal(data.start_date),
          registrationStart: formatToISTDatetimeLocal(
            data.registration_start_date,
          ),
          registrationEnd: formatToISTDatetimeLocal(data.registration_end_date),
          totalQuestions: data.total_questions || "",
          questionDuration: data.duration_per_question || "",
          enableSkippedMarks: !!data.negative_marks_skipped,
          enableWrongMarks: !!data.negative_marks_wrong,
          correct: data.marks_per_question || "",
          registrationCost: data.registration_fee,
          registrationFeeMode: data.registration_fee > 0.0 ? "paid" : "free",
          wrong: data.negative_marks_wrong || "",
          skipped: data.negative_marks_skipped || "",
          winnerPrizes: Object.values(data.prizes || {}),
          topWinnersCount: Object.keys(data.prizes || {}).length,
          about_quiz: data.about_quiz,
          quiz_terms: data.quiz_terms,
          updated_by: userId,
          prizeDescription: data.prizes,
          description: data.description,
          class_id: String(data.class_id || ""),
          class_ids: data.class_id || [],
          className: data.className || "",
          subject_id: String(data.subject_id || ""),
          themeData:
            subQuizType === 3
              ? data?.themeDetails?.length
                ? data.themeDetails
                : data?.theme_id?.length
                  ? data.theme_id
                  : []
              : [],
          group_idd: data.group_id,
        }),
      );
      if (subQuizType === 1 || subQuizType === 2) {
        const res = await dispatch(
          fetchSubjectBasedClassesData({
            subject_id: Number(data.subject_id),
          }),
        ).unwrap();

        // Now res contains your actual data, not a promise
        dispatch(
          setUpdateQuizForm({
            key: "subjectSpecificClasses",
            value: res,
          }),
        );
      } else {
      }
    }
    dispatch(
      setState({
        key: "option",
        value: option,
      }),
    );
    dispatch(
      setState({
        key: "showPopup",
        value: true,
      }),
    );
  };
  function formatPrizeValue(v) {
    if (v === null || v === undefined || v === "") return "-";
    // If numeric string, add Rupee symbol and two decimals
    const n = Number(String(v).replace(/[^0-9.-]+/g, ""));
    if (Number.isFinite(n)) return `₹${n.toFixed(2)}`;
    return String(v);
  }

  const closePopup = () => {
    dispatch(
      setState({
        key: "selectedQuiz",
        value: null,
      }),
    );
    dispatch(
      setState({
        key: "option",
        value: "",
      }),
    );
    dispatch(
      setState({
        key: "showPopup",
        value: false,
      }),
    );
  };
  const handleDelete = async (id) => {
    try {
      // const body = { quiz_id: Number(id), updated_by: Number(userId) };

      const res = await dispatch(
        deleteQuiz({
          quiz_id: Number(id),
          updated_by: Number(userId),
          quizType,
        }),
      );
      if (res) {
        console.log(res);
        alert("soft deleted the quiz");
        dispatch(getQuizzes(quizType));
        window.location.reload();
      }
    } catch (er) {
      console.error(er);
    }
  };
  const handlePublish = async (data) => {
    const id = data.id;
    try {
      const res = await dispatch(
        publishOrUnpublish({ id: id, quizType: subQuizType }),
      );
      console.log(res);

      // alert("res", res?.payload?.messge);
      // await dispatch(getQuizzes());
    } catch (err) {
      console.error(err);
    }
  };

  function formatText(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }

  const filteredQuizzes = quizzes?.filter((q) => {
    if (!searchTerm) return true; // no filter

    const term = searchTerm.toLowerCase();

    return (
      String(
        q.quiz_type === 1
          ? "Live Quiz"
          : q.quiz_type === 2
            ? "Practice Quiz"
            : "-",
      )
        .toLowerCase()
        .includes(term) ||
      String(q.title).toLowerCase().includes(term) ||
      String(q.status).toLowerCase().includes(term) ||
      new Date(q.start_date)
        .toLocaleString("en-IN")
        .toLowerCase()
        .includes(term) ||
      String(q.id).toLowerCase().includes(term)
    );
  });

  function formatTerms(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }

  const filteredList =
    quizType === "1"
      ? quizTypesList?.data.filter((e) => e.is_live === 1)
      : quizType === "0"
        ? quizTypesList?.data?.filter((e) => e.is_live === 0)
        : [];

  return (
    <div>
      <p style={{ fontSize: "20px", textAlign: "center" }}>
        View / Update Quizz(s)
      </p>
      <div className="grid grid-cols-1 rounded-3 p-1 bg-white shadow gap-4 relative ">
        <div
          className="table-responsive p-2 rounded-3"
          style={{ height: "70vh" }}
        >
          <div
            style={{
              position: "sticky",
              top: 0,
              background: "white",
              zIndex: 10,
              padding: "8px",
              display: "flex",
              gap: "2%",
            }}
          >
            <p>Quiz Type</p>
            <div className="col-sm-8 d-flex align-items-center gap-3">
              {[
                { label: "Live", value: "1" },
                { label: "Practice", value: "0" },
              ].map((option) => (
                <label
                  key={option.value}
                  className="form-check-label d-flex align-items-center gap-2"
                >
                  <input
                    type="radio"
                    className="form-check-input"
                    name="quizType"
                    value={option.value}
                    checked={quizType === option.value}
                    onChange={(e) => {
                      setQuizType(e.target.value);
                      setSubQuizType("");
                    }} // both string now ✅
                  />
                  {option.label}
                </label>
              ))}
            </div>
          </div>
          {quizType !== null && (
            <div style={{ display: "flex", gap: "2%" }}>
              {filteredList?.length > 0 && quizType && (
                <label>Sub Quiz Type</label>
              )}
              <div className="col-sm-8 d-flex align-items-center gap-3 flex-wrap">
                {filteredList?.map((quiz) => (
                  <label
                    key={quiz.id}
                    className="form-check-label d-flex align-items-center gap-2"
                  >
                    <input
                      type="radio"
                      className="form-check-input"
                      name="subQuizType"
                      value={quiz.id}
                      checked={Number(subQuizType) === quiz.id} // numeric comparison
                      onChange={(e) => {
                        const newValue = Number(e.target.value);
                        setSubQuizType(newValue);
                        dispatch(getQuizzes(newValue)); // use the new value directly
                      }}
                    />
                    {quiz.type.charAt(0).toUpperCase() + quiz.type.slice(1)}
                  </label>
                ))}
              </div>
            </div>
          )}
          {filteredQuizzes?.length > 0 && subQuizType && (
            <p>
              <strong>Matched Records Count : </strong>
              {filteredQuizzes?.length}
            </p>
          )}

          {subQuizType && filteredQuizzes?.length > 0 ? (
            <table
              className="table  table-striped table-bordered text-15"
              style={{ height: "10vh", overflow: "auto" }}
            >
              <tbody>
                <tr className="bg-gray-200 text-gray-700">
                  <th className="text-center">Sl No</th>
                  <th className="text-center">Quiz Type</th>
                  <th className="text-center">Title</th>
                  <th className="text-center">Status</th>
                  {quizType === "1" && (
                    <th className="text-center">Quiz Date</th>
                  )}{" "}
                  <th className="text-center">Actions</th>
                </tr>
                {/* {quizzes?.map((q, index) => ( */}
                {filteredQuizzes?.map((q, index) => (
                  <tr key={q.id} className="hover:bg-gray-100">
                    <td className="text-center">{index + 1} </td>

                    <td className="text-center">
                      {
                        quizTypesList?.data?.find((e) => e.id === subQuizType)
                          ?.type
                      }
                    </td>
                    <td className="text-center">{q.title}</td>
                    <td className="text-center">
                      <span
                      // className={`badge ${
                      //   q.status === "completed"
                      //     ? "badge-success"
                      //     : q.status === "ongoing"
                      //     ? "badge-info"
                      //     : "badge-warning"
                      // }`}
                      >
                        {q.status || "-"}
                      </span>
                    </td>
                    {quizType === "1" && (
                      <td className="text-center">
                        {" "}
                        {q.start_date
                          ? new Date(q.start_date).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "-"}
                      </td>
                    )}
                    <td className="text-center">
                      <img
                        width="24"
                        height="24"
                        src="https://img.icons8.com/material-rounded/24/visible.png"
                        alt="visible"
                        style={{ cursor: "pointer" }}
                        title="view quiz"
                        onClick={() => {
                          fetchParticipants(q, "view");
                          dispatch(
                            fetchSubjectBasedClassesData({
                              subject_id: q.subject_id,
                            }),
                          );

                          // if (q.class_id && quizType !== "thematic") {
                          //   dispatch(
                          //     fetchSubjectsByClassThunk(Number(q.class_id))
                          //   );
                          // }
                        }}
                      />
                      {(() => {
                        const regDate = new Date(q.registration_start_date);
                        const strtDate = new Date(q.start_date);
                        const now = new Date();

                        const isSameDateTime =
                          q.quiz_type === 1 || q.quiz_type === 3
                            ? regDate.getTime() < now.getTime()
                            : strtDate.getTime() < now.getTime();

                        // ✅ Always show buttons if quiz_type === 2
                        {
                          /* (quizType === 1 && q.quiz_type === 2) || */
                        }
                        const shouldShow =
                          quizType === 1 ||
                          (!isSameDateTime && q.status !== "deleted");

                        return shouldShow ? (
                          <>
                            <img
                              width="24"
                              height="24"
                              style={{ cursor: "pointer" }}
                              src="https://img.icons8.com/material-rounded/24/create-new.png"
                              alt="create-new"
                              title="edit quiz"
                              onClick={() => {
                                fetchParticipants(q, "edit");
                              }}
                            />
                            <img
                              width="24"
                              height="24"
                              style={{ cursor: "pointer" }}
                              title="delete quiz"
                              onClick={() => handleDelete(q.id)}
                              src="https://img.icons8.com/material-sharp/24/filled-trash.png"
                              alt="filled-trash"
                            />
                          </>
                        ) : null;
                      })()}
                      {/* {(q.status === "active" || q.status === "inactive") && (
                        <button onClick={() => handlePublish(q)}>
                          {q.status === "active" ? "Unpublish" : "Publish"}
                        </button>
                      )} */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: "red", textAlign: "center" }}>
              No Matching records Found
            </p>
          )}
          {/* Custom Popup Modal */}
          {showPopup && selectedQuiz && (
            <div className="popup-overlay">
              <div className="popup-content">
                {/* <button onClick={closePopup}>&times;</button> */}
                <img
                  width="20"
                  height="20"
                  src="https://img.icons8.com/ios/50/delete-sign--v1.png"
                  alt="delete-sign--v1"
                  style={{ float: "right", cursor: "pointer" }}
                  onClick={closePopup}
                />
                {option === "view" ? (
                  <>
                    <h3
                      className="mb-10"
                      style={{ fontSize: "23px", textAlign: "center" }}
                    >
                      {
                        quizTypesList?.data?.find((e) => e.id === subQuizType)
                          ?.type
                      }
                    </h3>
                    {/* {selectedQuiz.image_url} */}
                    {quizType !== 1 && selectedQuiz?.image_url && (
                      <div
                        className="text-xl text-30 mb-3 bg-white mx-auto"
                        style={{
                          borderRadius: "50%",
                          width: "100px",
                          height: "100px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          overflow: "hidden", // to keep it circular
                        }}
                      >
                        {selectedQuiz.image_url ? (
                          <img
                            src={`https://web1024.docmaster.in:5007/${selectedQuiz.image_url}`}
                            alt="no img"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover", // cover ensures it fills the circle
                            }}
                          />
                        ) : (
                          "-"
                        )}
                      </div>
                    )}
                    {subQuizType}
                    <h3 className="mb-10" style={{ fontSize: "18px" }}>
                      <strong>Title : </strong> {selectedQuiz.title}hisdcfv
                    </h3>
                    {/* <h3 className="mb-10" style={{ fontSize: "18px" }}>
                      <strong>Description : </strong> {selectedQuiz.description}
                    </h3> */}

                    {(subQuizType === 1 || subQuizType === 2) && (
                      <div style={{ display: "flex", gap: "4%" }}>
                        <h4 style={{ fontSize: "18px" }}>
                          <strong>Class : </strong>
                          {Array.isArray(selectedQuiz.class_id)
                            ? selectedQuiz.class_id
                                .map(
                                  (cid) =>
                                    classes.find((c) => c.class_id === cid)
                                      ?.class_name,
                                )
                                .filter(Boolean)
                                .join(", ")
                            : classes.find(
                                (c) => c.class_id === selectedQuiz.class_id,
                              )?.class_name || "-"}
                        </h4>
                        <h4 style={{ fontSize: "18px" }}>
                          <strong>Subject : </strong>
                          {Array.isArray(subjects)
                            ? subjects.find(
                                (s) =>
                                  String(s.subject_id) ===
                                  String(selectedQuiz.subject_id),
                              )?.subject_name || "-"
                            : "-"}
                        </h4>
                      </div>
                    )}
                    {subQuizType === 3 && (
                      <>
                        <p>
                          Theme details
                          {JSON.stringify(selectedQuiz?.themeDetails)}
                        </p>
                        <p>
                          Group Details :{" "}
                          {JSON.stringify(selectedQuiz?.group_id)}
                        </p>
                      </>
                    )}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Total Questions</th>
                          <th>Duration (Per Question)</th>
                          {quizType === "1" && (
                            <>
                              <th>Registration Type</th>
                              <th>Registration Fee</th>
                              <th>Registration Start</th>
                              <th>Registration End</th>
                              <th>Quiz Start Date</th>
                            </>
                          )}
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{selectedQuiz.total_questions}</td>
                          <td>{selectedQuiz.duration_per_question} sec</td>
                          {quizType === "1" && (
                            <>
                              <td>{selectedQuiz.registration_type}</td>
                              <td>
                                {selectedQuiz.registration_type === "paid"
                                  ? `₹${selectedQuiz.registration_fee}`
                                  : "-"}
                              </td>
                              <td>
                                {selectedQuiz.registration_start_date
                                  ? new Date(
                                      selectedQuiz.registration_start_date,
                                    ).toLocaleString("en-IN")
                                  : "-"}
                              </td>
                              <td>
                                {selectedQuiz.registration_end_date
                                  ? new Date(
                                      selectedQuiz.registration_end_date,
                                    ).toLocaleString("en-IN")
                                  : "-"}
                              </td>
                              <td>
                                {selectedQuiz.start_date
                                  ? new Date(
                                      selectedQuiz.start_date,
                                    ).toLocaleString("en-IN")
                                  : "-"}
                              </td>
                            </>
                          )}
                          <td>
                            <span
                              style={{
                                color: selectedQuiz?.status !== "" && "blue",
                              }}
                              // className={`badge ${
                              //   selectedQuiz.status === "qualified"
                              //     ? "badge-success"
                              //     : selectedQuiz.status === "disqualified"
                              //     ? "badge-danger"
                              //     : "badge-warning"
                              // }`}
                            >
                              {selectedQuiz.status || "-"}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <h4 className="mt-15" style={{ fontSize: "18px" }}>
                      <strong> Scoring Details:</strong>
                    </h4>
                    <ul style={{ marginLeft: "2%" }}>
                      <li>
                        Marks per Question: {selectedQuiz.marks_per_question}
                      </li>
                      <li>
                        Negative Marks (Wrong):{" "}
                        {selectedQuiz.negative_marks_wrong}
                      </li>
                      <li>
                        Negative Marks (Skipped):{" "}
                        {selectedQuiz.negative_marks_skipped}
                      </li>
                    </ul>

                    {selectedQuiz.prizes ? (
                      <>
                        <h4 className="mt-15" style={{ fontSize: "18px" }}>
                          <strong>Prize details</strong>
                        </h4>

                        {/* If prizes is an object like { "1": "500", "2": "300" } */}
                        {typeof selectedQuiz.prizes === "object" ? (
                          // Render object or array as a list
                          <div
                            style={{ marginTop: "10px", marginBottom: "2%" }}
                          >
                            <ul style={{ marginLeft: "2%" }}>
                              {Array.isArray(selectedQuiz.prizes)
                                ? selectedQuiz.prizes.map((p, i) => (
                                    <li key={i}>
                                      Rank {i + 1}: {formatPrizeValue(p)}
                                    </li>
                                  ))
                                : Object.entries(selectedQuiz.prizes).map(
                                    ([rank, prize]) => (
                                      <li key={rank}>
                                        Rank {rank}: {formatPrizeValue(prize)}
                                      </li>
                                    ),
                                  )}
                            </ul>
                          </div>
                        ) : (
                          // If it's a string, treat as preformatted HTML/text
                          <div
                            style={{
                              marginTop: "10px",
                              lineHeight: "1.6",
                              marginBottom: "2%",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: formatText1(String(selectedQuiz.prizes)),
                            }}
                          />
                        )}
                      </>
                    ) : null}

                    {quizType === "1" && (
                      <>
                        <h2 style={{ fontSize: "18px" }}>
                          <strong>Difficulty Level Allotment used</strong>
                        </h2>
                        {selectedQuiz.difficulty_allotment && (
                          <ul>
                            {selectedQuiz.difficulty_allotment.map(
                              (item, index) => (
                                <li key={index}>
                                  {item.difficulty_level} – {item.percentage}%
                                </li>
                              ),
                            )}
                          </ul>
                        )}
                      </>
                    )}
                    <h2 style={{ fontSize: "18px" }}>
                      <strong>About Quiz</strong>
                    </h2>
                    <p>{selectedQuiz.about_quiz}</p>

                    <h2 style={{ fontSize: "18px" }}>
                      <strong>Terms & Conditions</strong>
                    </h2>
                    <p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            quizType === "1"
                              ? convertTermsToHtml(selectedQuiz.quiz_terms)
                              : quizType === "0" || quizType === "2"
                                ? formatText(selectedQuiz?.quiz_terms)
                                : // : quizType === "thematic"
                                  // ? formatTerms(selectedQuiz.quiz_terms)
                                  "",
                        }}
                      />
                    </p>
                  </>
                ) : (
                  <EditQuiz
                    allotments={selectedQuiz.difficulty_allotment}
                    quizType={subQuizType}
                  />
                )}
              </div>
            </div>
          )}

          {/* Simple CSS styles */}
          <style>{`
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .popup-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 95%;
    max-width: 1800px;
    height: 90vh;
    max-height: 95vh;
    overflow-y: auto;
    position: relative;
  }

  .close-btn {
    position: absolute;
    right: 12px;
    top: 10px;
    font-size: 24px;
    background: none;
    border: none;
    cursor: pointer;
  }

  .close-btn:hover {
    color: red;
  }
`}</style>
        </div>
      </div>
    </div>
  );
};

export default QuizStatus;
